import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import EntityTypeIcon from '@icons/entity-type-icon';
import { Icon } from '@mui';
import MoreEntityCard from '@components/shared/list-card/more-entity-card';

const DetailCard = ({ entity, moreButton, showOutdated }) => {
  const clickAction = useCallback(() => {}, []);

  const getIcon = () => (
    <Icon role="img"><EntityTypeIcon type={entity.type_name} /></Icon>
  );

  return (
    <MoreEntityCard
      selectAction={clickAction}
      deselectAction={clickAction}
      openAction={clickAction}
      entity={entity}
      icon={getIcon()}
      border={false}
      moreButton={moreButton}
      showOutdated={showOutdated}
    />
  );
};

DetailCard.propTypes = {
  entity: PropTypes.object,
  moreButton: PropTypes.object,
  showOutdated: PropTypes.bool
};

export default DetailCard;
